import React from "react";

import Review from "./Review";

const AllReviewsOnePage = ({ currentReview }) => {
  console.log("currentReview", currentReview);
  window.scrollTo(0, 0);
  return (
    <div>
      {currentReview.map((review) => (
        <Review
          id={review.id}
          rating={review.rating}
          name={review.name}
          title={review.title}
          review={review.comment}
          imgs={review.images}
          created={review.created}
          uid={review.uid}
          admin={review.admin}
        />
      ))}
    </div>
  );
};

export default AllReviewsOnePage;
